import { Component, Injector, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { ApBaseModalComponent } from 'webcommon/core-ui';
import { AttachmentDto, AttachmentHandlerOptionsDto, DownloadableDocument, FacilityPatientResultsSearchResultsDto, FpResultsAttachmentDto } from 'webcommon/shared';
import { FpResultsService } from '../services/FpResultsService';
// import { AttachmentRepository } from 'webcommon/webapi';
// import { FpResultsComponent } from './fp-results.component';
// import { FpResultsService } from '../services/FpResultsService';
// import { finalize } from 'rxjs/operators';
// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';

@Component({
    selector: 'fp-results-viewer-modal',
    templateUrl: './fp-results-viewer-modal.component.html',
  })
  export class FpResultsViewerModalComponent extends ApBaseModalComponent<boolean> implements OnInit {
    baseId: string;
    Id: string;

    documentId: string;
    result: FacilityPatientResultsSearchResultsDto;
    isAttachment: boolean;
    activeAttachmentInfo: FpResultsAttachmentDto;
    attachmentInfos: FpResultsAttachmentDto[];

    showChips = false;

    constructor(
        elementInjector: Injector,
        private resultsService: FpResultsService,
        // private attachmentRepository: AttachmentRepository
      // private apNotificationService: ApNotificationService
    ) {
      super(elementInjector);
    }

  override ngOnInit() {
    super.ngOnInit();

    this.attachmentInfos = this.result.AttachmentInfos;

    if (this.isAttachment){
        this.documentId = this.result.AttachmentInfos[0].AttachmentUid;
        this.activeAttachmentInfo = this.result.AttachmentInfos[0];
    }
    else {
      this.documentId = this.result.PK;
    }

    if (this.result.AttachmentInfos && this.result.AttachmentInfos.length > 1) {
        this.showChips = true;
    }

    this.setId();
  }

  close() {
    super.closeModal(false);
  }

  setActiveAttachment(attachmentInfo: FpResultsAttachmentDto) {
    this.activeAttachmentInfo = attachmentInfo;
  }

  loadAttachmentRef = () => {
    if (this.isAttachment) {
        return this.loadAttachment();
    }
    else {
        return this.loadObservation();
    }
  };

  private loadAttachment(): Observable<AttachmentDto> {
    const loadAttachment$ = this.resultsService.getAttachment(this.documentId);
    return loadAttachment$;
  }

   private loadObservation(): Observable<AttachmentDto> {
     const loadAttachment$ = this.resultsService.getObservationOrderPdf(this.result.PatientUid,this.documentId);
     return loadAttachment$;
   }

  getDownloadDocumentRef = (attachmentId: string) => {
    return this.downloadDocument(attachmentId);
  };

  downloadDocument(attachmentId: string): Observable<DownloadableDocument> {
    return this.resultsService.getAttachmentForDownload(attachmentId);
  }

  getStaticUrlRef = () => {
    return this.getStaticUrl();
  };

  private getStaticUrl(): Observable<string> {
    // const loadStaticUrl$ = this.attachmentRepository.getAttachmentStaticUrl(this.documentId);
    const loadStaticUrl$ = this.resultsService.getAttachmentStaticUrl(this.documentId);
    return loadStaticUrl$;
  }

  getAttachmentHandlerRef = (attachmentId: string) => {
    return this.getAttachmentHandler(attachmentId);
  };

  private getAttachmentHandler(attachmentId: string): Observable<AttachmentHandlerOptionsDto> {
    console.log(attachmentId);
    const getAttachmentHandler$ = this.resultsService.getAttachmentHandler(this.documentId);
    return getAttachmentHandler$;
  }

  private setId() {
    this.Id = `${this.baseId}-viewer-modal`;
  }
}
